export const KYC_STATUSES = {
  accepted: 'ACCEPTED',
  rejected: 'REJECTED',
  needsInfo: 'NEEDS_INFO',
  processing: 'PROCESSING',
};
